import { defineStore } from "pinia"

interface DeviceState {
  deviceInfo: AnyObj
  globalDeviceInfo: AnyObj
  alarmLevelInfo: AnyObj | null
  alarmFaultInfo: AnyObj | null
  deviceDetail: AnyObj
}

const initDeviceInfo = {
  alarm: 0,
  last: 0,
  offline: 0,
  online: 0,
  total: 0
}

const initGlobalDeviceInfo = {
  alarm: 0,
  last: 0,
  offline: 0,
  online: 0,
  total: 0,
  regions: {}
}
/**
 * 访问权限相关
 */
export const useDeviceStore = defineStore("device", {
  actions: {
    setDeviceInfo(info: AnyObj) {
      this.deviceInfo = info
    },
    setGlobalDeviceInfo(info: AnyObj) {
      this.globalDeviceInfo = info
    },
    setAlarmLevelnfo(info: AnyObj) {
      this.alarmLevelInfo = info
    },
    setAlarmFaultInfo(info: AnyObj) {
      this.alarmFaultInfo = info
    },
    resetData() {
      this.deviceInfo = initDeviceInfo
      this.globalDeviceInfo = initGlobalDeviceInfo
      this.alarmLevelInfo = null
      this.alarmFaultInfo = null
    },
    setDeviceDetail(info: AnyObj) {
      this.deviceDetail = info
    }
  },
  state: (): DeviceState => ({
    deviceInfo: initDeviceInfo,
    globalDeviceInfo: initGlobalDeviceInfo,
    alarmLevelInfo: null,
    alarmFaultInfo: null,
    deviceDetail: {}
  })
})
